import React from 'react';
import { useMyOrgUnitAssortments, useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { OrgUnitAssortmentHeading, OrgUnitAssortmentSelect } from '@retail/components';

export const OrgUnitAssortmentSelectContainer: React.FC = () => {
  const { assortments, allAssortments } = useMyOrgUnitAssortments();
  const { selectedUserAssortment, selectOrgUnitAssortment } = useSelectedOrgUnit();

  if (allAssortments.length > 1) {
    return (
      <OrgUnitAssortmentSelect
        assortments={assortments}
        selectedAssortment={selectedUserAssortment}
        selectAssortment={selectOrgUnitAssortment}
      />
    );
  }

  return <OrgUnitAssortmentHeading name={selectedUserAssortment.name} />;
};
